(async () => {
    const { Core } = await importModule('Core');

    customElements.define('express-option-list', class extends Core {
        elements = {
            toCartButton: 'product-to-cart',
            selectedVariantPrice: '[data-selected-variant-price]',
        };

        connectedCallback() {
            super.connectedCallback();
            this._initialize();
        }

        _initialize() {
            if (!this._initialized) {
                this.render();
                this._initialized = true;
            } else {
                console.log('_initialize called, but component is already initialized.');
            }
        }

        render() {
            this.addEventListener('change', this._onSelect.bind(this));

            const toCartButton = this.querySelector('[data-to-cart]');
            if (toCartButton) {
                if (!toCartButton.hasEventListenerAttached) {
                    toCartButton.addEventListener('click', () => {
                        this._triggerAddToCartEvent();
                    });
                    toCartButton.hasEventListenerAttached = true;
                } else {
                    console.log('Add to Cart button already has event listener attached. Skipping setup.');
                }
            }

            this._applyMinQtyOnRender();
            this._observeInputChanges();
            this._setupQuantityInputEvents();
        }

        _applyMinQtyOnRender() {
            console.log("Applying minimum quantity on render...");
            const productData = JSON.parse(document.getElementById('product-data').dataset.product);

            if (productData.variants.length <= 1) {
                this._updateMinQtyForSingleVariant();
            } else {
                const firstVariant = this.querySelector('input[name="id"]');
                if (firstVariant && !firstVariant.checked) {
                    firstVariant.checked = true;
                    firstVariant.dispatchEvent(new Event('change'));
                }

                const selectedVariantElement = this.querySelector('input[name="id"]:checked');
                if (selectedVariantElement) {
                    this.selectedVariantId = selectedVariantElement.value;
                    this.minQty = parseInt(selectedVariantElement.dataset.minQuantity || 1, 10);
                    this._resetQtyToMin(this.minQty);
                    if (typeof this._updateSelectedVariantInfo === 'function') {
                        this._updateSelectedVariantInfo();
                    }
                }
            }
        }

        _updateMinQtyForSingleVariant() {
            const productData = JSON.parse(document.getElementById('product-data').dataset.product);
            const firstAvailableVariant = productData.variants[0];

            this.selectedVariantId = firstAvailableVariant.id;
            const variantInput = this.querySelector('input[name="quantity"]');
            if (variantInput) {
                const minQtyFromDataset = variantInput.dataset.variantMinQty || variantInput.dataset.productMinQty || variantInput.min;
                this.minQty = parseInt(minQtyFromDataset || 1, 10);
                this._resetQtyToMin(this.minQty);
            } else {
                this._resetQtyToMin(1);  // Default to 1 if no input found
            }

            const toCartButton = this.querySelector(this.elements.toCartButton);
            if (toCartButton) {
                toCartButton.setAttribute('variant-id', this.selectedVariantId);
                toCartButton.setAttribute('quantity', this.minQty);
            }
        }

        _resetQtyToMin(minQty) {
            const quantityInput = this.querySelector('input[name="quantity"]');
            if (quantityInput) {
                quantityInput.value = minQty;
                quantityInput.dispatchEvent(new Event('change'));

                const productDataElement = document.getElementById('product-data');
                const minQtyLabel = productDataElement ? productDataElement.dataset.minQtyLabel : '';
                const productData = document.getElementById("product-data");
                const minPurchaseLabel = productData.dataset.minPurchaseLabel;

                const qtyMinText = this.querySelector('#qty-min');
                if (qtyMinText) {
                qtyMinText.innerText = `${minPurchaseLabel} ${minQty} ${minQtyLabel}.`;
                }
            } else {
                setTimeout(() => this._resetQtyToMin(minQty), 100);
            }
        }

        _observeInputChanges() {
            const observer = new MutationObserver(() => {
                this._setupQuantityInputEvents();
            });
            observer.observe(this, { childList: true, subtree: true });
        }

        _setupQuantityInputEvents() {
            const quantityInput = this.querySelector('input[name="quantity"]');
            if (quantityInput) {
                const validateQty = (e) => {
                    if (parseInt(e.target.value, 10) < this.minQty) {
                        quantityInput.value = this.minQty;
                        quantityInput.dispatchEvent(new Event('change'));
                    }
                };

                quantityInput.addEventListener('blur', validateQty);
                quantityInput.addEventListener('change', validateQty);
                validateQty({ target: quantityInput });
            }
        }

        _onSelect(e) {
            if (e.target.matches('input[name="id"]')) {
                const productToCart = this.querySelector('product-to-cart');
                if (productToCart) {
                    productToCart.setAttribute('variant-id', e.target.value);
                    productToCart.setAttribute('quantity', this.minQty);
                }

                this.selectedVariantId = e.target.value;
                this.selectedVariantPrice = e.target.dataset.price;
                this.selectedVariantPriceLabel = e.target.dataset.priceLabel || '';
              
                const isSpecialOrder = e.target.dataset.specialOrder === "true";
                this._updateButtonLabel(isSpecialOrder);
                this._updateSelectedVariantPrice();
                this._updateQuantitySelectorVisibility(isSpecialOrder);
                this._applyMinQtyForSelectedVariant();
                this._updateSpecialOrderMessageVisibility(isSpecialOrder);
            }
        }

        _applyMinQtyForSelectedVariant() {
            const selectedVariant = this.querySelector('input[name="id"]:checked');
            if (!selectedVariant) {
                return;
            }

            this.minQty = parseInt(selectedVariant.dataset.minQuantity || 1, 10);
            this._resetQtyToMin(this.minQty);

            const minQtyLabel = selectedVariant.dataset.minQtyLabel || '';

            const qtyMinText = this.querySelector('#qty-min');
            if (qtyMinText) {
                if (this.minQty > 1) {
                    const productData = document.getElementById("product-data");
                    const minPurchaseLabel = productData.dataset.minPurchaseLabel;

                    qtyMinText.innerText = `${minPurchaseLabel} ${this.minQty} ${minQtyLabel}`.trim();
                    qtyMinText.style.display = '';
                } else {
                    qtyMinText.style.display = 'none';
                }
            }

            const qtyLabel = this.querySelector('#product-qty-selector-label');
            if (qtyLabel) {
                const qtyLabelSpan = qtyLabel.querySelector('span');
                const productData = document.getElementById("product-data");
                let unitLabel = productData.dataset.unitLabel;
      
                if (qtyLabelSpan) {
                    const vowels = ['a', 'e', 'i', 'o', 'u', 'y'];
                    const firstChar = minQtyLabel.charAt(1).toLowerCase();
                    if (vowels.includes(firstChar)) {
                        unitLabel = unitLabel.replace(/\bde\b/, "d'");
                    }

                    qtyLabelSpan.innerText = `| ${unitLabel} ${minQtyLabel}`.trim();
                }
            } else {
                console.error("Quantity label element with ID 'product-quantity-selector-label' could not be found in the DOM.");
            }
        }
      
_updateSelectedVariantPrice() {
    const selectedVariant = this.querySelector('input[name="id"]:checked');
    const priceTarget = this.querySelector(this.elements.selectedVariantPrice);

    if (!selectedVariant || !priceTarget) return;

    const variantId = selectedVariant.value;
    const storedPrice = this.querySelector(`.variant-price-store[data-variant-id="${variantId}"]`);

    if (storedPrice) {
        priceTarget.innerHTML = storedPrice.innerHTML;
    } else {
        priceTarget.innerText = "Unavailable";
    }
}

_updateButtonLabel(isSpecialOrder) {
    const buttonWrapper = this.querySelector('.add-to-cart-button');

    if (!buttonWrapper) {
        console.warn("Add to Cart button wrapper not found.");
        return;
    }

    if (isSpecialOrder) {
        buttonWrapper.classList.add('special-order');
    } else {
        buttonWrapper.classList.remove('special-order');
    }
}

_updateQuantitySelectorVisibility(isSpecialOrder) {
    const qtyWrapper = this.querySelector('.product-qty-selector-wrapper');

    if (!qtyWrapper) {
        console.error("Error: Quantity wrapper not found in DOM.");
        return;
    }

    console.log("Updating Quantity Selector Visibility:", isSpecialOrder);

    if (isSpecialOrder) {
        qtyWrapper.classList.add('special-order');
    } else {
        qtyWrapper.classList.remove('special-order');
    }
}
      
_updateSpecialOrderMessageVisibility(isSpecialOrder) {
    const specialOrderMessageWrapper = this.querySelector('.express-option-list-special-order');

    if (!specialOrderMessageWrapper) {
        console.error("Error: Special Order Message wrapper not found in DOM.");
        return;
    }

    console.log("Updating Special Order Message Visibility:", isSpecialOrder);

    if (isSpecialOrder) {
        specialOrderMessageWrapper.classList.add('special-order');
    } else {
        specialOrderMessageWrapper.classList.remove('special-order');
    }
}

      
        async _triggerAddToCartEvent() {

            const mainVariantId = this.selectedVariantId;
            const mainQuantityInput = this.querySelector('input[name="quantity"]');
            const mainQuantity = mainQuantityInput ? Math.max(parseInt(mainQuantityInput.value, 10), this.minQty) : this.minQty;

            try {
                const productToCart = this.querySelector('product-to-cart');
                if (productToCart) {
                    productToCart.setAttribute('variant-id', mainVariantId);
                    productToCart.setAttribute('quantity', mainQuantity);
                    productToCart.click();
                }
            } catch (error) {
                console.error("Error handling add to cart process:", error);
            } finally {
                console.log("Add to cart process completed.");
            }
        }
    });
})();